import { render, staticRenderFns } from "./akc_liaoyuan.vue?vue&type=template&id=67bd830e&scoped=true&"
import script from "./akc_liaoyuan.vue?vue&type=script&lang=js&"
export * from "./akc_liaoyuan.vue?vue&type=script&lang=js&"
import style0 from "./akc_liaoyuan.vue?vue&type=style&index=0&id=67bd830e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bd830e",
  null
  
)

export default component.exports